import { RootState } from '../types';

export const assetClaimSelector = ({ assetClaim }: RootState) => assetClaim;
